<template>
    <v-btn        
        text
        v-on:click="logOut"
        color="primary"
      >
        <span class="mr-2">Logout</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            primaryColor: 'app/getPrimaryColor',
        })
        
    },
    methods: {
        ...mapActions({
            signOut: 'auth/signOut'
        }),

        ...mapMutations({
            setOverlay: 'app/setAppOverlay',
            setWelcomeMessage: 'mainMenu/setWelcomeMessage',
            setMarkSheetLoading: 'markSheet/setMarkSheetLoading', 
            setPrintViewReports: 'mainMenu/setReports',
            setEditViewStudents: 'mainMenu/setEditViewStudents',
            setResetPassword: 'mainMenu/setResetPassword', 
            setStep: 'auth/setStep',
            setAuthenticated: 'auth/setAuthenticated',
        }),

        async logOut () {            
            this.setOverlay(true);
            this.setWelcomeMessage(true);
            this.setMarkSheetLoading(false);
            this.setPrintViewReports(false);
            this.setResetPassword(false);
            this.setStep(1);
            this.setAuthenticated(false);
            try {
                await this.signOut();
            } catch (error) {
                if(error.response) console.log(error.response);
            }            
            
            this.setOverlay(false);
            
            this.$router.replace('/');
        }        
    }
}
</script>